<!-- 書類毎の承認までかかる平均時間 datasetsとかlabels入れたら表示できる-->
<script>
import { Bar } from "vue-chartjs";
export default {
  extends: Bar,
  name: "ApprovalDocumentTimeAverage",
  type: "bar",
  // データを分割表示するためのprops
  props: {indexMin: String, indexMax: String, default: () => {return {indexMin: "", indexMax: ""}}},
  data() {
    return {
      data: {
        datasets: [
          {
            label: "書類別平均時間(秒)",
            data: [10, 20, 30, 10, 50],
            backgroundColor: "#98df8a",
          },
        ],
        labels: [
          "document1",
          "document2",
          "document3",
          "document4",
          "document5",
        ],
      },
      options: {
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "書類",
              },
              ticks: {
                autoSkip: true,
                min: "",
                max: "",
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                //stepSize: 10
                beginAtZero: true,
                autoSkip: true,
                callback: function (value) {
                  return value;
                },
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    approvalDocumentTimeAverageList: function () {
      return this.$store.getters["domain/approvalDocumentTimeAverageList"];
    },
  },
  watch: {
    approvalDocumentTimeAverageList(val) {
      if (val) {
        this.overwriteGraphData(val);
      }
      this.renderChart(this.data, this.options);
    },
    indexMin (val) {
      this.$set(this.options.scales.xAxes[0].ticks, "min", val || "");
      this.renderChart(this.data, this.options);
    },
    indexMax (val) {
      this.$set(this.options.scales.xAxes[0].ticks, "max", val || "");
      this.renderChart(this.data, this.options);
    }
  },
  mounted() {
    const val = this.$store.getters["domain/approvalDocumentTimeAverageList"];
    this.overwriteGraphData(val);
    this.renderChart(this.data, this.options);
  },
  methods: {
    overwriteGraphData: function (val) {
      let documentId = [];
      let approvalDocumentTimeAverage = [];
      for (let i = 0; i < val.length; i++) {
        const data = val[i];
        documentId.push(data.document_id);
        approvalDocumentTimeAverage.push(data.time_to_approval);
      }
      this.$set(this.data.datasets[0], "data", approvalDocumentTimeAverage);
      this.$set(this.data, "labels", documentId);
    },
    formatTime: function (seconds) {
      var result = "";
      var hour = Math.floor(seconds / 60 / 60);
      var min = Math.floor((seconds / 60) % 60);
      var sec = Math.floor(seconds % 60);

      if (hour > 0) {
        result += hour + "時間";
      }
      if (min > 0) {
        result += min + "分";
      }
      if (sec > 0) {
        result += sec + "秒";
      }
      return result;
    },
},
};
</script>
